import React from 'react';
import { useHistory } from 'react-router-dom';

const HeaderChatBtn = (props) => {
    
    const history = useHistory();

    const handleInbox = () => {
        history.push('/user/inbox');
		window.location.reload();	
	}

    return (
        <div 
            className="cart-btn" 
            onClick={handleInbox}
        >
            <i className={
                props.bgColor === "color" ? 
                    "far fa-envelope" : 
                    props.navbar ? 
                    "far fa-envelope" : "far fa-envelope color-white"
                }
            ></i> 
            <span className="cart-counter red2-bg">{props.unreadMsgs}</span>
        </div>
    );
};

export default HeaderChatBtn;

